import React, { createContext, useContext } from "react";
import { useCartLogic } from "../hooks/useCart"; 


type CartContextType = ReturnType<typeof useCartLogic>;

const CartContext = createContext<CartContextType | null>(null);

type Props = {
  children: React.ReactNode;
};

export const CartProvider = ({ children }: Props) => {
  const cart = useCartLogic(); 
  return (
    <CartContext.Provider value={cart}>
      {children}
    </CartContext.Provider>
  );
};

// Custom hook for accessing cart context
export function useCart() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
}
